module.exports = __webpack_public_path__ + "components/rewards/dogtag/static/logo-9a91e3d9dab7691a83140be424803f3f.webp";